import { render, staticRenderFns } from "./listleave.vue?vue&type=template&id=32faecfc&scoped=true&"
import script from "./listleave.vue?vue&type=script&lang=js&"
export * from "./listleave.vue?vue&type=script&lang=js&"
import style0 from "./listleave.vue?vue&type=style&index=0&id=32faecfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32faecfc",
  null
  
)

export default component.exports